import { CiCircleRemove } from "react-icons/ci";
import ButtonTextIcon from "../../../components/ui/ButtonTextIcon";
import { AiOutlineMail } from "react-icons/ai";
import { IoIosPhonePortrait } from "react-icons/io";
import { IoMdClose } from "react-icons/io";
import { useEffect, useMemo } from "react";
import { useLocation, useNavigate } from "react-router-dom";

const NotificationPopup = ({
  SelectedCustomers,
  setSelectedCustomers,
  setShow,
}) => {
  const location = useLocation();
  const navigate = useNavigate();

  const removeCustomer = (id) => {
    setSelectedCustomers((prev) =>
      prev.filter((customer) => customer.id !== id)
    );
  };

  const queryParams = useMemo(() => {
    const searchParams = new URLSearchParams(location.search);
    const params = {};
    searchParams.forEach((value, key) => {
      params[key] = value;
    });
    return params;
  }, [location.search]);

  // Function to navigate with updated tab parameter
  const navigateWithTab = (tabValue) => {
    const newSearchParams = new URLSearchParams(queryParams);
    //remove all parms ]
    newSearchParams.delete("pageNo");
    newSearchParams.delete("pageSize");
    newSearchParams.set("tab", tabValue); // Set the tab query param
    setShow(false);
    navigate(`/customers/notification?${newSearchParams.toString()}`);
  };

  const filterCriteria = useMemo(() => {
    const filterType = queryParams.filterType;
    if (!filterType) return "No Filter Applied";

    const filters = {
      email: ` Email = ${queryParams.search || "N/A"}`,
      name: ` Name = ${queryParams.search || "N/A"}`,
      accountNumber: ` Account Number = ${queryParams.search || "N/A"}`,
      balance: ` Balance is between ${queryParams.minBalance || "N/A"} and ${
        queryParams.maxBalance || "N/A"
      }`,
      date: ` Date is between ${queryParams.startDate || "N/A"} and ${
        queryParams.endDate || "N/A"
      }`,
      status: ` Status ID = ${
        queryParams.statusID === "1" ? "Active" : "Inactive" || "N/A"
      }`,
    };

    return filters[filterType] || "No Filter Applied";
  }, [queryParams]);

  // useEffect(() => {
  //   if (SelectedCustomers.length === 0) {
  //     setShow(false);
  //   }
  // }, [SelectedCustomers, setShow]);

  return (
    <div
      className="responsive-container pos-rel"
      style={{
        display: "block",
        minWidth: "500px",
        maxWidth: "600px",
        padding: "40px 20px 20px 20px",
        borderRadius: "10px",
        backgroundColor: "#fff",
        boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
      }}
    >
      <CiCircleRemove
        className="cursor-pointer transition hover-color-primary"
        style={{
          position: "absolute",
          top: "10px",
          right: "10px",
          fontSize: "32px",
          color: "#555",
        }}
        onClick={() => setShow(false)}
      />
      <div>
        {/* <p className="f-w-300">
          Filter Criteria: Select all where &nbsp;
          <span className="f-w-600">{filterCriteria}</span>
        </p> */}
        {/* <p className="f-w-300">
          Customer Selected: <span className="f-w-600">{SelectedCustomers.length}</span>
        </p> */}
      </div>

      {/* Selected Customers Section */}
      {/* <div style={{ maxHeight: "250px", overflowY: "auto", padding: "10px", backgroundColor: "#fff", borderRadius: "5px", margin: "10px 0" }}>
        <div className="flex wrap" style={{ display: "flex", flexWrap: "wrap", gap: "10px" }}>
          {SelectedCustomers.length >= 1 ? (
            SelectedCustomers.map((item) => (
              <div
                className="flex center-center p.small b-r-5"
                key={item.id}
                style={{
                  border: "1px solid #ddd",
                  padding: "8px 12px",
                  borderRadius: "5px",
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                  backgroundColor: "#f8f8f8",
                  boxShadow: "0 2px 5px rgba(0,0,0,0.1)",
                }}
              >
                <span>{item.name}</span>
                <IoMdClose
                  onClick={() => removeCustomer(item.id)}
                  style={{
                    cursor: "pointer",
                    color: "red",
                    fontSize: "16px",
                  }}
                />
              </div>
            ))
          ) : (
            <div
              className="flex center-center p.small b-r-5"
              style={{
                border: "1px solid #ddd",
                padding: "8px 12px",
                borderRadius: "5px",
                display: "flex",
                alignItems: "center",
                gap: "8px",
                backgroundColor: "#f8f8f8",
                boxShadow: "0 2px 5px rgba(0,0,0,0.1)",
              }}
            >
              <span>No Customer Selected</span>
            </div>
          )}
        </div>
      </div> */}

      {/* Notification Methods */}
      <p className="col-4-5">Send Notification VIA:</p>
      <div
        className="flex center-center"
        style={{ gap: "20px", padding: "10px" }}
      >
        <ButtonTextIcon
          type="button"
          title={"Email"}
          // disabled={SelectedCustomers.length === 0}
          icon={<AiOutlineMail />}
          onClick={() => navigateWithTab("email")} // Navigate with tab=email
        />
        <ButtonTextIcon
          type="button"
          title={"Push App"}
          // disabled={SelectedCustomers.length === 0}
          icon={<IoIosPhonePortrait />}
          onClick={() => navigateWithTab("app")} // Navigate with tab=app
        />
      </div>
    </div>
  );
};

export default NotificationPopup;
